import React from "react";
import {Box} from "grommet";
import BeatLoader from "react-spinners/BeatLoader";

export const LoadingBar = () => (
    <Box fill align="center" justify="center">
        <BeatLoader size={25} color={"#F7BCB8"}/>
    </Box>
);
